import styled from 'styled-components';
import { Menu as AntMenu } from 'antd';
import AntSubMenu from 'antd/es/menu/SubMenu';

export const Container = styled.div.attrs(() => ({
  className: 'container',
}))`
  width: 100%;
  padding: 0 20px;
  max-width: 1490px;
  margin: 0 auto;
  position: relative;

  @media (max-width: 767px) {
    .product-layout .main & {
      padding: 0 8px;
      background: var(--white);
    }
  }
`;

export const MenuWrapper = styled.div`
  position: absolute;
  top: -20px;
  z-index: 3;
  display: flex;
  padding: 20px 0;
  left: 462px;
  width: auto;

  @media (max-width: 844px) {
    width: 100%;
    left: 0 !important;
  }

  @media (max-width: 767px) {
    > .ant-menu {
      padding-top: 39px;
    }
  }
`;

export const CloseBtn = styled.button`
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  background: var(--white);
  padding: 0;
  position: absolute;
  right: 9px;
  top: 8px;
  opacity: 0.6;
  cursor: pointer;
  border: 1px solid var(--grey20);
  border-radius: 50%;
  color: var(--carbone70);
  transition: var(--transition);
  z-index: 4;
  display: none;

  .icon_close {
    left: -0.5px;
    top: -0.5px;
    font-size: 10px;
  }

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 767px) {
    display: flex;
  }
`;

export const Mask = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.45);
`;

export const Menu = styled(AntMenu)`
  width: 250px;

  @media (max-width: 844px) {
    width: 100%;
  }
  position: relative;

  &.ant-menu-light .ant-menu-item:hover,
  &.ant-menu-light .ant-menu-item-active,
  &.ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  &.ant-menu-light .ant-menu-submenu-active,
  &.ant-menu-light .ant-menu-submenu-title:hover {
    color: var(--theme-palette-brand-color);
  }

  //> .ant-menu-submenu {
  //  pointer-events: none;
  //}
`;

export const SubMenu = styled(AntSubMenu)`
  .ant-menu-item:hover,
  .ant-menu-item-active,
  .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-submenu-active,
  .ant-menu-submenu-title:hover {
    color: var(--theme-palette-brand-color);
  }

  .ant-menu-submenu-title:active {
    background: var(--theme-palette-brand-menu-hover);
  }

  .ant-menu-light .ant-menu-item:hover,
  .ant-menu-light .ant-menu-item-active,
  .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
  .ant-menu-light .ant-menu-submenu-active,
  .ant-menu-light .ant-menu-submenu-title:hover {
    color: var(--theme-palette-brand-color);
  }
`;
